import { render, staticRenderFns } from "./Wise_rentunit2.vue?vue&type=template&id=60245313&scoped=true"
import script from "./Wise_rentunit2.vue?vue&type=script&lang=js"
export * from "./Wise_rentunit2.vue?vue&type=script&lang=js"
import style0 from "./Wise_rentunit2.vue?vue&type=style&index=0&id=60245313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60245313",
  null
  
)

export default component.exports